/**
 * @generated SignedSource<<21016f5dd1d98f63788578706e91e036>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type StorePackageDetailFooter_package$data = {
  readonly __typename: string;
  readonly id: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"usePackageDisplayName_package">;
  readonly " $fragmentType": "StorePackageDetailFooter_package";
};
export type StorePackageDetailFooter_package$key = {
  readonly " $data"?: StorePackageDetailFooter_package$data;
  readonly " $fragmentSpreads": FragmentRefs<"StorePackageDetailFooter_package">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorePackageDetailFooter_package",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "usePackageDisplayName_package"
    }
  ],
  "type": "Package",
  "abstractKey": "__isPackage"
};

(node as any).hash = "e9bc503498cedb9b5b65a32e68193cdb";

export default node;
